module.exports = function ($el) {
  const self = {
    $el: $el,
    $body: $('body, html'),
    is_mobile_device: $('html').hasClass('mobile-device')
  };

  self.$el.find('.cross').on('click', hide);

  function show () {
    self.$el.addClass('show');
    self.$body.addClass('no-scroll');

    if (self.is_mobile_device && self.$el.hasClass('contain-inputs')) {
      //var decal = $(document).scrollTop() + ($(window).height() - self.$el.find('.popin').height(true))/2
      self.$el.find('.popin').css('margin-top', $(document).scrollTop());
    }
  }

  function hide () {
    self.$el.removeClass('show');
    self.$body.removeClass('no-scroll');
  }

  // TODO useless ?
  function toggle_loading () {
    self.$el.find('.popin').toggleClass('loading');
  }

  return {
    hide: hide,
    show: show,
    toggle_loading: toggle_loading
  }
};
